import { SingleSelectOption } from '@/modules/common';
import { EntityAvatar } from '@/modules/common/components/molecules/avatar/entity-avatar';
import { getMemberStatusText } from '@/modules/common/components/molecules/badge/status-configs/team-member-status-config';
import { mapMemberStatusFromDTO } from '@/modules/common/mappers/member-status.mapper';
import { MemberStatusDTO } from '@/modules/common/types/dto/member-status.dto';

/**
 * Custom render option for user dropdown items.
 * Shows avatar, name, and status badge.
 */
export const renderUserOption = (option: SingleSelectOption) => (
  <div className="flex w-full items-center gap-2">
    <EntityAvatar
      image={option.avatar ?? undefined}
      name={option.label}
      size="xs"
      alt={option.label}
    />
    <div className="flex min-w-0 flex-1 flex-col items-start justify-between gap-0.5">
      <span className="truncate">{option.label}</span>
      <span className="truncate text-xs text-muted-foreground">
        {getMemberStatusText(mapMemberStatusFromDTO(option.status as MemberStatusDTO))}
      </span>
    </div>
  </div>
);

/**
 * Custom render trigger for user dropdown.
 * Shows avatar, name, and status badge when an option is selected.
 */
export const renderUserTrigger = (
  selectedOption: SingleSelectOption | null,
  placeholder: string
) => (
  <div className="flex w-full items-center">
    {selectedOption ? (
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <EntityAvatar
          image={selectedOption.avatar ?? undefined}
          name={selectedOption.label}
          size="xs"
          alt={selectedOption.label}
          className="flex-shrink-0"
        />
        <span className="truncate text-sm font-normal">{selectedOption.label}</span>
      </div>
    ) : (
      <span className="truncate text-sm font-normal text-muted-foreground">{placeholder}</span>
    )}
  </div>
);
